import React from 'react';
import './LoginPage.css';
import Button from '../../components/Button';
import { useNavigate } from 'react-router-dom';

const RegistrationSuccess = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate('/login');
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-form">
          <div style={{ fontSize: '3rem', color: 'green', marginBottom: '0.5rem' }}>✔</div>
          <h2 style={{ marginBottom: '0.5rem' }}>Success!</h2>
          <p style={{ marginBottom: '1.5rem' }}>
              You have successfully registered. <br />
              Please verify your account by checking the confirmation email we just sent. <br />
              If you do not see the email in your inbox, kindly check your <b>Spam</b> or Junk folder and mark it as "Not Spam" to ensure future messages are delivered correctly.
          </p>
          <Button type="button" onClick={handleContinue}>
            Continue to Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccess;
